const isOdd = num => {
  return num % 2 ? true : false;
};

export default isOdd;
